import React from "react";
import { observer } from "mobx-react";
import { EventOffer } from "@gp/offer";

export const EventTeamAggregatedScore = observer(
	function EventTeamAggregatedScore({
		event,
		team,
	}: {
		event: EventOffer;
		team: "home" | "away";
	}) {
		if (!event.result?.aggregateScore) {
			return null;
		}

		return (
			<div className="event__aggregate__item">
				({event.result.aggregateScore[team] || 0})
			</div>
		);
	}
);
